import React, { useEffect, useState } from 'react';

// Props: isOpen, onClose, onSave(taskData)
// taskData shape: { title, description, domain, cepaCategory, status, priority, dueAt }
const AddTaskModal = ({ isOpen, onClose, onSave, className }) => {
  const [form, setForm] = useState({
    title: '',
    description: '',
    domain: 'personal',
    cepaCategory: 'identify',
    status: 'open',
    priority: 'medium',
    dueAt: '',
  });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    setForm({ title: '', description: '', domain: 'personal', cepaCategory: 'identify', status: 'open', priority: 'medium', dueAt: '' });
    setErrors({});
  }, [isOpen]);

  if (!isOpen) return null;

  const setField = (k, v) => {
    setForm((prev) => ({ ...prev, [k]: v }));
    if (errors[k]) setErrors((e) => ({ ...e, [k]: undefined }));
  };

  const validate = () => {
    const e = {};
    if (!form.title.trim()) e.title = 'Title is required';
    if (!form.dueAt) e.dueAt = 'Due date is required';
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    setSubmitting(true);
    try {
      await onSave({ ...form });
    } finally {
      setSubmitting(false);
    }
  };

  const stop = (e) => e.stopPropagation();

  return (
    <div className="fixed inset-0 z-50" onClick={onClose}>
      <div className="absolute inset-0 bg-black/40" />
      <div className="absolute inset-0 flex items-center justify-center p-4">
        <div className={`bg-succession-bg-primary w-full max-w-2xl rounded-xl shadow-xl overflow-hidden border border-succession-border ${className || ''}`} onClick={stop}>
          <div className="px-6 py-4 border-b border-succession-border flex items-center justify-between">
            <div className="text-lg font-semibold text-succession-text-primary">Add New Task</div>
            <button className="px-3 py-2 text-sm text-succession-text-primary" onClick={onClose}>Close</button>
          </div>

          <div className="p-6 space-y-5">
            <div className="space-y-2">
              <label className="text-sm text-succession-text-primary">Title *</label>
              <input className={`w-full border border-succession-border bg-succession-bg-primary text-succession-text-primary rounded-md px-3 py-2 ${errors.title ? 'border-red-300' : ''}`} value={form.title} onChange={(e) => setField('title', e.target.value)} />
              {errors.title && <div className="text-xs text-red-600">{errors.title}</div>}
            </div>

            <div className="space-y-2">
              <label className="text-sm text-succession-text-primary">Description</label>
              <textarea className="w-full border border-succession-border bg-succession-bg-primary text-succession-text-primary rounded-md px-3 py-2" rows={4} value={form.description} onChange={(e) => setField('description', e.target.value)} />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-2">
                <label className="text-sm text-succession-text-primary">Domain</label>
                <select className="w-full border border-succession-border bg-succession-bg-primary text-succession-text-primary rounded-md px-3 py-2" value={form.domain} onChange={(e) => setField('domain', e.target.value)}>
                  <option value="personal">Personal</option>
                  <option value="business">Business</option>
                </select>
              </div>
              <div className="space-y-2">
                <label className="text-sm text-succession-text-primary">VMI Category</label>
                <select className="w-full border border-succession-border bg-succession-bg-primary text-succession-text-primary rounded-md px-3 py-2" value={form.cepaCategory} onChange={(e) => setField('cepaCategory', e.target.value)}>
                  <option value="identify">Identify</option>
                  <option value="protect">Protect</option>
                  <option value="build">Build</option>
                  <option value="harvest">Harvest</option>
                  <option value="manage">Manage</option>
                </select>
              </div>
              <div className="space-y-2">
                <label className="text-sm text-succession-text-primary">Priority</label>
                <select className="w-full border border-succession-border bg-succession-bg-primary text-succession-text-primary rounded-md px-3 py-2" value={form.priority} onChange={(e) => setField('priority', e.target.value)}>
                  <option value="low">Low</option>
                  <option value="medium">Medium</option>
                  <option value="high">High</option>
                </select>
              </div>
              <div className="space-y-2">
                <label className="text-sm text-succession-text-primary">Due Date *</label>
                <input type="date" className={`w-full border border-succession-border bg-succession-bg-primary text-succession-text-primary rounded-md px-3 py-2 ${errors.dueAt ? 'border-red-300' : ''}`} value={form.dueAt} onChange={(e) => setField('dueAt', e.target.value)} />
                {errors.dueAt && <div className="text-xs text-red-600">{errors.dueAt}</div>}
              </div>
            </div>
          </div>

          <div className="px-6 py-4 border-t border-succession-border bg-succession-bg-secondary flex items-center justify-end gap-2">
            <button className="px-3 py-2 text-sm border border-succession-border rounded text-succession-text-primary" onClick={onClose}>Cancel</button>
            <button className={`px-3 py-2 text-sm rounded text-white bg-succession-primary hover:bg-succession-primary/90`} onClick={handleSubmit} disabled={submitting}>
              {submitting ? 'Creating...' : 'Create Task'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddTaskModal;


